import { useEffect, useState } from "react";
import { Card, FormGroup, FormLabel } from "react-bootstrap";
import { getRandomInt, parsePossibleMcElroyQrCode, useForceRender } from "../util/utils";
import { SimpleFormField } from "../components/SimpleFormField";
import { InspectionComponent } from "../models/InspectionComponent";

export function MachineForm(props) {
	let { inspection, survey } = props;
	const color = "#007041";

	// Sort the componentTypes by the user-specified position
	survey.surveyComponentTypes.sort((a, b) => a.position - b.position);

	let components = new Map();
	if(inspection){
		if(inspection.components){
			for(const val of Object.values(inspection.components)){
				components.set(val.componentTypeId, val);
			}
		}
		else if(inspection.inspectionComponents){
			for(const val of Object.values(inspection.inspectionComponents)){
				components.set(val.componentTypeId, val);
			}
		}
	}
	
	// FIXME - primarySCTId needs to come from the server, eventually
	let primaryCTId = survey.surveyComponentTypes[0]?.componentTypeId;
	if(primaryCTId != null) {
		inspection.primaryComponentTypeId = primaryCTId;
	}

	// This maps the component id to the component model and serial number fields. Should look like this
	// {
	// 	cid1: {
	// 		model: m1
	// 		serial: s1
	//  	name: component1
	// 	},
	// 	cid2: {
	// 		model: m2
	// 		serial: s2
	//  	name: component2
	// 	}
	// }
	const [value, setValue] = useState(Object.fromEntries(components.entries()));


	useEffect(() => {
		let initialValue = {};
		for(const sct of survey.surveyComponentTypes) {
			let cid = sct.componentTypeId;

			let x = null;
			if(cid in value){
				x = {...value[cid], name: sct.componentType.name };
			} else {
				x = {"modelNumber": "", "serialNumber": "", "componentTypeId": cid, "name": sct.componentType.name};
			}
			initialValue[cid] = x;
		};
		setValue(initialValue);
		inspection.setInspectionComponentDetails(initialValue);

	}, [survey]);

	inspection.setInspectionComponentDetails(value);


	const getComponentFields = function (){
		return Object.values(value).map(comp => {

			const cid = comp.componentTypeId;
			let runPossibleMcElroyScan = (scanText) => {
				let qrResult = parsePossibleMcElroyQrCode(scanText);
				if(qrResult == null) {
					return false; // Let it keep processing
				}
				setValue({...value, [cid]: {
					...value[cid],
					"modelNumber": qrResult.mn,
					"serialNumber": qrResult.sn,
				}})
				return true; // Stop processing
			};
			return <div key={cid}>
				<h4 className="mt-4">{value[cid]?.name}</h4>
				<SimpleFormField className="mt-3" color={color} value={value[cid]?.modelNumber}  onChange={(e) => {setValue( { ...value, [cid]: { ...value[cid], "modelNumber" : e.target.value } }); }} label="Model #" scannable={true} onScan={runPossibleMcElroyScan} key={`model_${cid}`} />
				<SimpleFormField className="mt-3" color={color} value={value[cid]?.serialNumber} onChange={(e) => {setValue( { ...value, [cid]: { ...value[cid], "serialNumber" : e.target.value } }); }} label="Serial #" scannable={true} onScan={runPossibleMcElroyScan} key={`serial_${cid}`} />
			</div>
		} )
	}


    return (
        <Card className="mt-3">
			<Card.Header>
				<Card.Title>Machine Information</Card.Title>
			</Card.Header>
            <Card.Body>
				{getComponentFields()}
            </Card.Body>
        </Card>
    );
}